import tippy from 'tippy.js'

tippy(document.querySelectorAll('.js-sidebar-tooltip'), {
  appendTo: document.querySelector('.page-wrapper'),
  placement: 'right',
  arrowType: 'small',
  arrow: true,
  animation: 'fade'
})



// WEBPACK FOOTER //
// ./resources/assets/command-center/js/tippy.js